<template>
    <form class="cbs-passenger-details-form" @submit.prevent="onSubmit">
        <div class="row">
            <div class="col-md-6 col-12">
                <div class="cbs-passenger-details-form-passenger-title">
                    <label class="check">
                        <input type="radio" name="passengerTitle" value="Mr." v-model="salutation" />
                        <span class="checkmark"></span> Mr.
                    </label>
                    <label class="check">
                        <input type="radio" name="passengerTitle" value="Ms." v-model="salutation" />
                        <span class="checkmark"></span> Ms.
                    </label>
                </div>
            </div>
            
            <div class="col-md-6 col-12">
                <label class="check">
                    <input type="checkbox" name="hasMeetAndGreet" v-model="hasMeetAndGreet"/>
                    <span class="checkmark"></span> Add Meet & Greet service
                </label>
            </div>

            <div class="col-md-6 form-group">
                <!--<label for="contact:name">First Name *</label>-->
                <input type="text" value="" class="form-control" name="firstName" placeholder="First name"
                       :value="firstName" @input="updateField('firstName', $event)" :class="{ error: $v.firstName.$error }">
                <div v-if="$v.firstName.$dirty">
                    <div class="error-message" v-if="!$v.firstName.required">First name is required.</div>
                </div>
            </div>

            <div class="col-md-6 form-group">
                <!--<label for="contact:name">Last Name *</label>-->
                <input type="text" value="" class="form-control" name="lastName" placeholder="Last name"
                       :value="lastName" @input="updateField('lastName', $event)" :class="{ error: $v.lastName.$error }">
                <div v-if="$v.lastName.$dirty">
                    <div class="error-message" v-if="!$v.lastName.required">Last name is required.</div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 form-group">
                <!--<label for="contact:email">E-mail Address v-model.trim="email"  *</label>-->
                <input type="email" value="" class="form-control" name="email" placeholder="Email"
                       :value="email" @input="updateField('email', $event)" :class="{ error: $v.email.$error }">
                <div v-if="$v.email.$dirty">
                    <div class="error-message" v-if="!$v.email.email">Email address is not valid. Keep typing...</div>
                    <div class="error-message" v-if="$v.email.$dirty && !$v.email.required">Email address is required.</div>
                </div>
            </div>

            <div class="col-md-6 form-group">
                <!--  -->
                <vue-tel-input class="form-control" v-model="phoneNumber" @onInput="onPhoneInput" :enabledFlags="true" 
                               :preferredCountries="['gb','us','de','fr','cn']">
                </vue-tel-input>
                <div v-if="$v.phone.$dirty">
                    <div class="error-message" v-if="!$v.phone.required">Phone number is require in case chauffeur needs to contact you.</div>
                </div>
            </div>
        </div>

        <hr />
        <div class="row">
            <div class="col-md-6 form-group">
                <!--<label for="smallChildrenNumber">Adults number</label>-->
                <NumberInputSpinner :min="0" :max="100" :integerOnly="true" buttonClass="vnis__button btn-spinner"
                                    name="adultsNumber" title="Adults Number" placeholder="Passengers"
                                    :value="adultsNumber" @input="updateSpinner('adultsNumber', $event)"
                                    :class="{ error: $v.adultsNumber.$error }" />
                <div><p>How many passengers? (including children)</p></div>
                <div v-if="$v.adultsNumber.$dirty">
                    <div class="error-message" v-if="!$v.adultsNumber.required">Passengers number is required.</div>
                </div>
            </div>

            <!--<div class="col-md-4">
                <label for="smallChildrenNumber">Children > 7 years</label>
                <NumberInputSpinner :min="0" :max="100" :integerOnly="true"
                                    buttonClass="vnis__button btn-spinner"
                                    name="childrenNumber" title="Children younger than 7"
                                    placeholder="Children younger than 7"
                                    :value="childrenNumber" @input="updateSpinner('childrenNumber', $event)"
                                    :class="{ error: $v.childrenNumber.$error }" />
                <div v-if="$v.childrenNumber.$dirty">
                    <div class="error-message" v-if="!$v.childrenNumber.required">Children older than 7 is required.</div>
                </div>
            </div>-->

            <div class="col-md-6 form-group">
                <!--<label for="smallChildrenNumber">Children < 7 years</label>-->
                <NumberInputSpinner :min="0" :max="100" :integerOnly="true" buttonClass="vnis__button btn-spinner"
                                    name="childrenNumber" title="Child seats number" placeholder="Child seats"
                                    :value="childrenNumber" @input="updateSpinner('childrenNumber', $event)"
                                    :class="{ error: $v.childrenNumber.$error }" />
                <div><p>How many child seats are required?</p></div>
                <div v-if="$v.childrenNumber.$dirty">
                    <div class="error-message" v-if="!$v.childrenNumber.required">Child seats number is required.</div>
                </div>
            </div>
            <!--<div class="col-sm-12">
                <p>Passengers number is Adults </p>
            </div>-->
            <!--<div class="col-md-4 form-group">
                <NumberInputSpinner :min="0" :max="100" :integerOnly="true" buttonClass="vnis__button btn-spinner"
                                    name="luggageNumber" title="Luggage number" placeholder="Luggage number"
                                    :value="luggageNumber" @input="updateSpinner('luggageNumber', $event)"
                                    :class="{ error: $v.luggageNumber.$error }" />
                <div v-if="$v.luggageNumber.$dirty">
                    <div class="error-message" v-if="!$v.luggageNumber.required">Luggage number is required.</div>
                </div>
            </div>-->
            <!--
            //TODO: maybe add these as errors on check prices page .. or warnings     
            -->
            <div class="col-12">
                <div class="text-danger text-center mt-10" v-show="exceedCapacity">
                    Number of persons exceed car capacity. Please select different vehicle or make multiple reservations.
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 cbs-passenger-details-form-passenger-title">
                <label class="check">
                    <input type="checkbox" name="arrivingByPlane" v-model="arrivingByPlane" />
                    <span class="checkmark"></span> Arriving by plane
                </label>
            </div>
        </div>

        <div class="row" v-show="arrivingByPlane">
            <div class="col-md-6">
                <input type="text" value="" class="form-control" name="flightNumber" placeholder="Flight number"
                       :value="flightNumber" @input="updateField('flightNumber', $event)">
            </div>

            <div class="col-md-6">
                <input type="text" value="" class="form-control" name="flightArivingFrom" placeholder="Ariving from"
                       :value="comingFrom" @input="updateField('comingFrom', $event)">
            </div>
        </div>

        <div class="row" v-show="arrivingByPlane">
            <div class="col-md-6">
                <NumberInputSpinner :min="0" :max="100" :integerOnly="true" buttonClass="vnis__button btn-spinner"
                                    name="largeLuggageNumber" title="Checked Luggages" placeholder="Checked Luggages"
                                    :value="largeLuggageNumber" @input="updateSpinner('largeLuggageNumber', $event)" />
            </div>
            <div class="col-md-6">
                <NumberInputSpinner :min="0" :max="100" :integerOnly="true" buttonClass="vnis__button btn-spinner"
                                    name="mediumLuggageNumber" title="Carry-on Luggages" placeholder="Carry-on Luggages"
                                    :value="mediumLuggageNumber" @input="updateSpinner('mediumLuggageNumber', $event)" />
            </div>
        </div>

        <div class="clearfix">
            <textarea maxlength="10000" rows="4" class="form-control" name="passengerDriverExtraComments" 
                      placeholder="Tell the driver how many luggage do you have and any additional comment ..."
                      :value="driverInstructions" @input="updateField('driverInstructions', $event)"></textarea>
        </div>

        <div class="row mt-30">
            <div class="col-12 cbs-passenger-details-form-passenger-title">
                <label class="check">
                    <input type="checkbox" name="differentBilling" v-model="differentBilling" />
                    <span class="checkmark"></span> Billing details (if different than passenger details)
                </label>
            </div>
            <div class="col-12">
                <div v-show="differentBilling">
                    <div class="row">
                        <div class="col-md-6">
                            <input type="text" value="" class="form-control" name="companyName" placeholder="Company/Person name"
                                   :value="companyName" @input="updateField('companyName', $event)">
                        </div>
                        <div class="col-md-6">
                            <input type="text" value="" class="form-control" name="companyTaxNumber" placeholder="Tax number (Ex: VAT number, if any)"
                                   :value="companyTaxNumber" @input="updateField('companyTaxNumber', $event)">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <input type="text" value="" class="form-control" name="companyAddress" placeholder="Address"
                                   :value="companyAddress" @input="updateField('companyAddress', $event)">
                        </div>
                        <div class="col-md-6">
                            <input type="text" value="" class="form-control" name="companyAdditionalAddress" placeholder="Additional address"
                                   :value="companyAdditionalAddress" @input="updateField('companyAdditionalAddress', $event)">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-20">
            <div class="col-md-12">
                <button type="button" class="btn btn-primary float-left" @click="goToCarSelection">Change Car </button>
                <button type="submit" class="btn btn-primary float-right"> 
                    <i class="fa fa-spinner fa-spin" v-show="isPriceLoading"></i> Continue 
                </button>
            </div>
        </div>

        <!--
    <div class="validators">
        <pre>{{$v}}</pre>
    </div>
    -->
    </form>
</template>

<script>
    import 'vue-tel-input/dist/vue-tel-input.css';
    import HtmlPageService from "../services/htmlPageService"
    import Vue from 'vue';
    import VueTelInput from 'vue-tel-input'
    import Vuelidate from 'vuelidate';
    import { required, email } from 'vuelidate/lib/validators';
    import { mapState } from 'vuex';

    import NumberInputSpinner from '../components/vue-number-spinner/vueNumberSpinner.vue'

    Vue.use(Vuelidate);

    export default {
        name: "PassengerDetails",
        data: function () {
            return { }
        },
        validations: {
            email: { required, email },
            firstName: { required },
            lastName: { required },
            adultsNumber: { required },
            childrenNumber: { required },
            //luggageNumber: { required },
            phone: { required }
        },
        components: { NumberInputSpinner, VueTelInput },
        computed: {
            salutation: {
                get: function () {
                    return this.$store.state.bookingInfo.passengerDetails.salutation;
                },
                set: function (value) {
                    this.$store.commit("setPassengerDetailsProperty", { propertyName: 'salutation', value: value });
                }
            },
            hasMeetAndGreet: {
                get: function () {
                    return this.$store.state.bookingInfo.passengerDetails.hasMeetAndGreet;
                },
                set: function (value) {
                    this.updateSpinner('hasMeetAndGreet', value)
                }
            },
            exceedCapacity: function () {
                var adults = this.$store.state.bookingInfo.passengerDetails.adultsNumber;
                if (!adults) adults = 0
                let carCapacity = this.$store.state.bookingInfo.selectedCar.numberOfPassengers;
                if (!carCapacity) carCapacity = 3;
                return adults > carCapacity;
               // var children = this.$store.state.bookingInfo.passengerDetails.childrenNumber;
                //if (!children) children = 0;
                //let carCapacity = this.$store.state.bookingInfo.selectedCar.numberOfPassengers;
                //if (!carCapacity) carCapacity = 3;
               // console.log(carCapacity);
               
            },
            differentBilling: {
                get: function () { return this.$store.state.bookingInfo.passengerDetails.differentBilling; },
                set: function (value) { this.$store.commit("setPassengerDetailsProperty", { propertyName: 'differentBilling', value: value }); }
            },
            arrivingByPlane: {
                get: function () { return this.$store.state.bookingInfo.passengerDetails.arrivingByPlane; },
                set: function (value) { this.$store.commit("setPassengerDetailsProperty", { propertyName: 'arrivingByPlane', value: value }); }
            },
            phoneNumber: {
                get: function () { return this.$store.state.bookingInfo.passengerDetails.phone; },
                set: function (value) {
                    //console.log(value);
                    //this.$store.commit("setPassengerDetailsProperty", { propertyName: 'arrivingByPlane', value: value });
                }
            },
            ...mapState({                
                email: state => state.bookingInfo.passengerDetails.email,
                phone: state => state.bookingInfo.passengerDetails.phone,
                firstName: state => state.bookingInfo.passengerDetails.firstName,
                lastName: state => state.bookingInfo.passengerDetails.lastName,

                adultsNumber: state => state.bookingInfo.passengerDetails.adultsNumber,
                childrenNumber: state => state.bookingInfo.passengerDetails.childrenNumber,
                smallChildrenNumber: state => state.bookingInfo.passengerDetails.smallChildrenNumber,

                flightNumber: state => state.bookingInfo.passengerDetails.flightNumber,
                comingFrom: state => state.bookingInfo.passengerDetails.comingFrom,
                roomNumber: state => state.bookingInfo.passengerDetails.roomNumber,
                driverInstructions: state => state.bookingInfo.passengerDetails.driverInstructions,

                companyName: state => state.bookingInfo.passengerDetails.companyName,
                companyTaxNumber: state => state.bookingInfo.passengerDetails.companyTaxNumber,
                companyAddress: state => state.bookingInfo.passengerDetails.companyAddress,
                companyAdditionalAddress: state => state.bookingInfo.passengerDetails.companyAdditionalAddress,

                largeLuggageNumber: state => state.bookingInfo.passengerDetails.largeLuggageNumber,
                mediumLuggageNumber: state => state.bookingInfo.passengerDetails.mediumLuggageNumber,

                //hasMeetAndGreet: state => state.bookingInfo.passengerDetails.hasMeetAndGreet,

                //helper properties
                //arrivingByPlane: state => state.bookingInfo.passengerDetails.arrivingByPlane,
                //differentBilling: state => state.bookingInfo.passengerDetails.differentBilling,
                //isLoading: state => state.bookingInfo.passengerDetails.isLoading,

                isPriceLoading: state => state.bookingInfo.general.isPriceLoading
            })
        },
        methods: {
            /**
             * @param {string} number
             * the phone number inputted by user, will be formatted along with country code
             * // Ex: inputted: (AU) 0432 432 432
             * // number = '+61432421546'
             *
             * @param {Boolean} isValid
             * @param {string} country
             */
            onPhoneInput({ number, isValid, country }) {
                //console.log(number, isValid, country);
                if (isValid) {
                    this.updateFieldwithValue('phone', number);
                }
            },
            updateSpinner(name, value) {
                console.log('spinner update ' + name + " value " + value);
                this.$store.commit("setPassengerDetailsProperty", { propertyName: name, value: value });
                if (name === 'childrenNumber' || name === 'hasMeetAndGreet')
                    this.$store.dispatch('updateBookingPrice');

                if (this.$v[name])
                    this.$v[name].$touch();
            },
            updateField(name, e) {
                var valueToSet = e.target.value.trim();
                this.updateFieldwithValue(name, valueToSet);
            },
            updateFieldwithValue(name, valueToSet) {
                this.$store.commit("setPassengerDetailsProperty", { propertyName: name, value: valueToSet });

                if (this.$v[name])
                    this.$v[name].$touch();
            },
            goToCarSelection: function () {
                this.$store.commit("setCurrentStep", 2);
            },
            goToPayment: function () { },
            onSubmit() {
                console.log('form submitted');
                this.$v.$touch();
                if (this.isPriceLoading || this.exceedCapacity) return;

                if (!this.$v.$invalid) {
                    this.$store.commit("setCurrentStep", 4);
                } else {
                    //scroll to first form error
                    HtmlPageService.scrollElement('.error', 10)
                }
            }
        }
    }
</script>

<style>
    .cbs-passenger-details-form {
        background-color: #fff;
        padding: 20px;
        padding-top: 10px;
    }

        .cbs-passenger-details-form .checkbox + .checkbox, .cbs-passenger-details-form .radio + .radio {
            margin-top: 0 !important;
        }

        .cbs-passenger-details-form .cbs-passenger-details-form-title {
            font-size: 18px;
            margin-bottom: 5px;
        }

        .cbs-passenger-details-form .cbs-passenger-details-form-passenger-title label.checkbox {
            font-weight: normal;
            color: unset;
        }

        .cbs-passenger-details-form .checkbox input:checked + i {
            border-color: #c6c6c6;
        }

        .cbs-passenger-details-form .checkbox input + i:after {
            color: #7b7b7b;
            top: 2px;
            left: 2px;
        }

        .cbs-passenger-details-form .radio i, .cbs-passenger-details-form .checkbox i {
            width: 21px;
            height: 21px;
            border-width: 1px;
            border-color: #ddd;
        }

        .cbs-passenger-details-form .btn-spinner {
            background-color: white;
            color: black;
            border: 1px solid #ddd;
        }

        .cbs-passenger-details-form input[type=number]::-webkit-outer-spin-button,
        .cbs-passenger-details-form input[type=tel]::-webkit-outer-spin-button,
        .cbs-passenger-details-form input[type=number]::-webkit-inner-spin-button,
        .cbs-passenger-details-form input[type=tel]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        .cbs-passenger-details-form input[type=number],
        .cbs-passenger-details-form input[type=tel] {
            -moz-appearance: textfield;
        }

        .cbs-passenger-details-form input::placeholder {
            color: #6c757d;
            opacity: 1;
        }

        .cbs-passenger-details-form input {
            color: black !important;
        }

    .error-message {
        color: red;
        font-size: 12px;
        margin-top: 3px;
    }
</style>